import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ num, title, children }) => (
  <div style={{ marginBottom: '32px' }}>
    <h2 style={{ fontSize: '18px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '12px', borderLeft: '4px solid var(--primary-color)', paddingLeft: '12px' }}>
      {num}. {title}
    </h2>
    <div style={{ color: 'var(--text-secondary)', fontSize: '15px', lineHeight: '1.8' }}>
      {children}
    </div>
  </div>
);

const TermosDeUso = () => {
  const dataAtualizacao = '14 de abril de 2025';

  return (
    <div className="container" style={{ padding: 'var(--spacing-xl) var(--spacing-md)', maxWidth: '860px', margin: '0 auto' }}>
      {/* Breadcrumb */}
      <div style={{ marginBottom: '24px' }}>
        <Link to="/" style={{ color: 'var(--text-secondary)', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '6px', textDecoration: 'none' }}>
          <i className="fas fa-arrow-left"></i> Voltar para a Home
        </Link>
      </div>

      <div style={{ backgroundColor: 'var(--white)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-sm)', padding: '40px' }}>
        {/* Cabeçalho */}
        <div style={{ marginBottom: '40px', paddingBottom: '24px', borderBottom: '1px solid var(--border-color)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <i className="fas fa-file-contract" style={{ fontSize: '28px', color: 'var(--primary-color)' }}></i>
            <h1 style={{ fontSize: '28px', fontWeight: '800', color: 'var(--text-primary)', margin: 0 }}>
              Termos de Uso
            </h1>
          </div>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
            Última atualização: <strong>{dataAtualizacao}</strong> &nbsp;|&nbsp; Versão 1.0
          </p>
          <div style={{ marginTop: '16px', padding: '16px', backgroundColor: 'rgba(52, 131, 250, 0.06)', borderRadius: '8px', border: '1px solid rgba(52, 131, 250, 0.15)', fontSize: '14px', color: '#1a56c4', lineHeight: '1.6' }}>
            <i className="fas fa-info-circle" style={{ marginRight: '8px' }}></i>
            Ao acessar ou usar o <strong>Ofertiz</strong>, você concorda com estes Termos de Uso. Leia-os com atenção antes de utilizar a plataforma. Se não concordar com qualquer parte, não utilize o site.
          </div>
        </div>

        <Section num="1" title="Sobre o Ofertiz">
          <p>O <strong>Ofertiz</strong> (<em>ofertiz.com.br</em>) é uma plataforma gratuita de curadoria de ofertas e descontos. Nosso objetivo é reunir as melhores promoções disponíveis em lojas parceiras e oferecer aos usuários ferramentas como favoritos, comentários e programa de recompensas (Ofertiz Coins).</p>
          <p style={{ marginTop: '10px' }}>O Ofertiz é um <strong>intermediário de informações</strong>. As vendas efetivas são realizadas diretamente pela loja parceira; o Ofertiz não realiza vendas, não processa pagamentos e não entrega produtos.</p>
        </Section>

        <Section num="2" title="Uso Permitido">
          <p>Ao utilizar o Ofertiz, você se compromete a:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>Fornecer informações verdadeiras no cadastro.</li>
            <li style={{ marginBottom: '6px' }}>Não criar contas falsas ou representar outra pessoa.</li>
            <li style={{ marginBottom: '6px' }}>Não publicar comentários com conteúdo ofensivo, spam, discurso de ódio ou violação de direitos de terceiros.</li>
            <li style={{ marginBottom: '6px' }}>Não tentar burlar o sistema de recompensas (Ofertiz Coins) por meios artificiais.</li>
            <li style={{ marginBottom: '6px' }}>Não fazer uso automatizado (bots, scrapers) sem autorização prévia por escrito.</li>
          </ul>
        </Section>

        <Section num="3" title="Cadastro e Conta">
          <p>Para acessar funcionalidades como comentários, favoritos e recompensas, é necessário criar uma conta. Você é responsável por:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>Manter a confidencialidade da sua senha.</li>
            <li style={{ marginBottom: '6px' }}>Todas as atividades realizadas com suas credenciais.</li>
            <li style={{ marginBottom: '6px' }}>Notificar imediatamente o Ofertiz em caso de uso não autorizado da sua conta.</li>
          </ul>
          <p style={{ marginTop: '10px' }}>O Ofertiz reserva-se o direito de suspender ou encerrar contas que violem estes Termos.</p>
        </Section>

        <Section num="4" title="Programa de Recompensas (Ofertiz Coins)">
          <p>O Ofertiz oferece um programa de recompensas onde usuários acumulam moedas virtuais (<strong>Ofertiz Coins</strong>) ao interagir com a plataforma (curtir ofertas, comentar, acessar links, seguir redes sociais).</p>
          <p style={{ marginTop: '10px' }}><strong>Importante:</strong></p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>As Ofertiz Coins são créditos virtuais sem valor monetário garantido.</li>
            <li style={{ marginBottom: '6px' }}>O Ofertiz pode, a seu critério, permitir o resgate de moedas por benefícios, descontos ou prêmios.</li>
            <li style={{ marginBottom: '6px' }}>As regras de resgate podem ser alteradas a qualquer tempo, com aviso prévio na plataforma.</li>
            <li style={{ marginBottom: '6px' }}>Ofertiz Coins obtidos por meios fraudulentos serão cancelados e a conta poderá ser suspensa.</li>
          </ul>
        </Section>

        <Section num="5" title="Ofertas e Links de Terceiros">
          <p>As ofertas publicadas no Ofertiz são provenientes de lojas parceiras ou curadoria da equipe. O Ofertiz:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}><strong>Não garante</strong> a disponibilidade, preço ou prazo das ofertas apresentadas.</li>
            <li style={{ marginBottom: '6px' }}>Pode utilizar <strong>links de afiliado</strong>, sendo remunerado pela loja quando uma compra é realizada através desses links.</li>
            <li style={{ marginBottom: '6px' }}>Não se responsabiliza por <strong>problemas de entrega, qualidade do produto ou atendimento</strong> da loja parceira.</li>
          </ul>
          <p style={{ marginTop: '10px' }}>Ao clicar em um link de oferta, você será redirecionado ao site da loja parceira, sujeito aos Termos de Uso e Política de Privacidade daquela plataforma.</p>
        </Section>

        <Section num="6" title="Conteúdo do Usuário (Comentários)">
          <p>Ao publicar comentários no Ofertiz, você:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>Concede ao Ofertiz licença não exclusiva para exibir e moderar o conteúdo.</li>
            <li style={{ marginBottom: '6px' }}>Afirma que o conteúdo não viola direitos de terceiros.</li>
            <li style={{ marginBottom: '6px' }}>Compreende que comentários podem ser removidos pela moderação se violarem estas regras.</li>
          </ul>
        </Section>

        <Section num="7" title="Propriedade Intelectual">
          <p>Todo o conteúdo do Ofertiz (marca, logotipo, layout, código-fonte, textos) é protegido por direitos autorais. É proibida a reprodução total ou parcial sem autorização prévia e por escrito do Ofertiz.</p>
          <p style={{ marginTop: '10px' }}>As imagens de produtos pertencem às lojas parceiras e são utilizadas para fins de curadoria e informação.</p>
        </Section>

        <Section num="8" title="Limitação de Responsabilidade">
          <p>O Ofertiz é fornecido <em>"no estado em que se encontra"</em>, sem garantia de disponibilidade contínua. Não somos responsáveis por:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>Interrupções temporárias de serviço.</li>
            <li style={{ marginBottom: '6px' }}>Danos decorrentes de decisões tomadas com base nas informações do site.</li>
            <li style={{ marginBottom: '6px' }}>Ações ou omissões das lojas parceiras.</li>
          </ul>
        </Section>

        <Section num="9" title="Privacidade e Proteção de Dados">
          <p>
            O tratamento dos seus dados pessoais é regido pela nossa{' '}
            <Link to="/politica-de-privacidade" style={{ color: 'var(--primary-color)', fontWeight: '600' }}>
              Política de Privacidade
            </Link>
            , em conformidade com a LGPD (Lei nº 13.709/2018). Ao criar uma conta, você consente com o tratamento dos dados necessários para o funcionamento da plataforma.
          </p>
        </Section>

        <Section num="10" title="Alterações nos Termos">
          <p>O Ofertiz pode atualizar estes Termos a qualquer momento. Quando isso ocorrer, publicaremos a nova versão nesta página com a data de vigência atualizada. O uso continuado da plataforma após a publicação das alterações implica na aceitação dos novos Termos.</p>
        </Section>

        <Section num="11" title="Lei Aplicável e Foro">
          <p>Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de <strong>Jequié — BA</strong> para dirimir quaisquer controvérsias, ressalvada a competência de juizados especiais cíveis.</p>
        </Section>

        <Section num="12" title="Contato">
          <div style={{ padding: '20px', backgroundColor: 'rgba(52, 131, 250, 0.05)', borderRadius: '8px', border: '1px solid rgba(52, 131, 250, 0.15)' }}>
            <p>Dúvidas sobre estes Termos? Entre em contato:</p>
            <p style={{ marginTop: '8px' }}>
              📧 <a href="mailto:contato@ofertiz.com.br" style={{ color: 'var(--primary-color)' }}>contato@ofertiz.com.br</a><br />
              📞 (75) 98146-2701
            </p>
          </div>
        </Section>

        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '24px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Link to="/politica-de-privacidade" style={{ color: 'var(--primary-color)', fontSize: '14px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-shield-alt"></i> Ver Política de Privacidade
          </Link>
          <Link to="/" style={{ color: 'var(--text-secondary)', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-home"></i> Voltar para a Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermosDeUso;
